// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetIsEditable = () => getClaimDefaultState().isEditable;

const updateClaimMode = (state, action) => action.isEditable;

export default (state = getClaimDefaultState().isEditable, action) => {

    const actionTypes = {
        [actions.COPY_CLAIM_MAINTENANCE_PLAN]: resetIsEditable,
        [actions.ADD_CLAIM_MAINTENANCE_PLAN_ADDITIONAL_REPAIR]: resetIsEditable,
        [actions.RESET_CLAIM_MAINTENANCE_PLAN]: resetIsEditable,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_IS_EDITABLE]: updateClaimMode
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/is-editable.js